import { DateInt8 } from '@cawita/core-front';
import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '@shared/modules/crud';
import { Interest } from './interest.model';
import { User } from './user.model';


export enum ProfileGender {
    Male = 'male',
    Female = 'female',
    NoAnswer = 'noAnswer'
}

export enum ProfileSituation {
    Married = 'married',
    Single = 'single',
    NoAnswer = 'noAnswer'
}

@CwtModel({ name: 'profile', path: '/profile' })
export class Profile extends ApiData {
    user?: User;
    interests?: Interest[];
    blockedGender?: string[];
    braceletId?: string;
    blockedProfiles?: Profile[];
    birthDate?: DateInt8;
    country?: string;
    gender?: ProfileGender;
    campingType?: string;
    languages?: string[];
    situation?: ProfileSituation;
    ageIsPrivate?: boolean;

    fieldDictionary() {
        return {
            ...super.fieldDictionary(),
            user: User
        };
    }
}
